import React, {useState} from 'react';
import {
  IconLocation,
  IconUser,
  // IconCheck,
  // IconChevronLeft,
  // IconChevronRight,
  // IconSpinner,
} from "../../../../../components/icons";
import {useFormik} from "formik";
import {Proprietaire} from "../../../../../components/models";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import {createProprietaire, updateProprietaire} from "../../../../../components/requests";

interface ProprietaireProps {
  nom?: string;
  adresse?: string;
  adresse2?: string;
  adresse3?: string;
  ville?: string;
  cp?: string;
  telephone?: string;
  mobile?: string;
  telephonePro?: string;
  email?: string;
  pays?: string;
  sexe?: string;
}

type ProprietaireErrors = Partial<Record<keyof ProprietaireProps, string>>;

const validate = (values: ProprietaireProps): ProprietaireErrors => {
  const errors: ProprietaireErrors = {};

  if (!values.nom || values.nom.trim().length === 0) {
    errors.nom = 'Ce champ est requis';
  }
  if (!values.adresse) {
    errors.adresse = 'Ce champ est requis';
  }
  if (!values.ville) {
    errors.ville = 'Ce champ est requis';
  }
  if (!values.cp) {
    errors.cp = 'Ce champ est requis';
  }
  if (!values.telephone) {
    errors.telephone = 'Ce champ est requis';
  }
  // if (!values.pays) {
  //   errors.pays = 'Ce champ est requis';
  // }
  if (!values.sexe) {
    errors.sexe = 'Ce champ est requis';
  }

  return errors;
};

const ProprietaireForm = (
  {
    proprietaire = null,
    setProprietaire = null,
    // setIsActive = null
  }: {
    proprietaire?: Proprietaire | null,
    setProprietaire?: any | null,
    // setIsActive?: any | null,
  }) => {
  const {id} = useParams();
  const [proprietaireId, setProprietaireId] = useState<number | null>(null);
  // const [isValideLoading, setIsValideLoading] = useState<boolean>(false);
  // const [isBrouillonLoading, setIsBrouillonLoading] = useState<boolean>(false);
  // const [isBrouillon, setIsBrouillon] = useState<boolean | null>(null);

  const formik = useFormik({
    initialValues: {
      nom: proprietaire ? proprietaire.nom : '',
      adresse: proprietaire ? proprietaire.adresse : '',
      adresse2: proprietaire ? proprietaire.adresse2 : '',
      adresse3: proprietaire ? proprietaire.adresse3 : '',
      ville: proprietaire ? proprietaire.ville : '',
      cp: proprietaire ? proprietaire.cp : '',
      telephone: proprietaire ? proprietaire.telephone : '',
      mobile: proprietaire ? proprietaire.mobile : '',
      telephonePro: proprietaire ? proprietaire.telephonePro : '',
      email: proprietaire ? proprietaire.email : '',
      pays: proprietaire ? proprietaire.pays : '',
      sexe: proprietaire ? proprietaire.sexe : '',
    },
    enableReinitialize: true,
    validate,
    onSubmit: (values: ProprietaireProps) => {
      // if (isBrouillon) setIsBrouillonLoading(true)
      // else setIsValideLoading(true);

      let payload = {
        nom: values.nom,
        adresse: values.adresse,
        adresse2: values.adresse2,
        adresse3: values.adresse3,
        ville: values.ville,
        cp: values.cp,
        telephone: values.telephone,
        mobile: values.mobile,
        telephonePro: values.telephonePro,
        email: values.email,
        pays: values.pays,
        sexe: values.sexe,
        // brouillon: isBrouillon,
        ...((!proprietaire) ? {dossier: `api/dossiers/${id}`} : {})
      };

      const method = (!proprietaire) ? createProprietaire(payload) : updateProprietaire((proprietaire.id) ? proprietaire.id : proprietaireId, payload)
      method
        .then((response) => {
          if ((response.status === 200 || response.status === 201) && response.data !== undefined) {
            setProprietaire({
              ...((!proprietaire) ? {} : {id: proprietaire.id}),
              nom: payload.nom,
              adresse: payload.adresse,
              adresse2: payload.adresse2,
              adresse3: payload.adresse3,
              ville: payload.ville,
              cp: payload.cp,
              telephone: payload.telephone,
              telephonePro: payload.telephonePro,
              email: payload.email,
              pays: payload.pays,
              sexe: payload.sexe,
              // brouillon: payload.brouillon,
            })
            if (!proprietaire) setProprietaireId(response.data['@id'].split('/').pop())
            toast.success(`Propriétaire ${(!proprietaire) ? 'créé' : 'modifié'}`);
          }
        })
        .catch((error) => console.error(error))
        .finally(() => {
          // if (isBrouillon) setIsBrouillonLoading(false)
          // else setIsValideLoading(false);
        })
    },
  });

  return (
    <>
      {/*<form onSubmit={formik.handleSubmit}>*/}
      <div className="p-4 animate-in fade-in duration-300">
        <div className="grid grid-cols-2 gap-4">
          <div className="section-card">
            <div className="section-header">
              <div className="section-icon bg-blue-100 text-blue-600">
                <IconUser/>
              </div>
              <span className="section-title">Identification</span></div>
            <div className="section-body grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <label className="form-label">Nom</label>
                <input
                  name="nom"
                  type="text"
                  className="form-input font-mono hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nom}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.nom ? <div className="text-xs text-red-600">
                  {formik.errors.nom}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Téléphone</label>
                <input
                  name="telephone"
                  type="text"
                  className="form-input font-mono hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.telephone}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.telephone ? <div className="text-xs text-red-600">
                  {formik.errors.telephone}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Mobile</label>
                <input
                  name="mobile"
                  type="text"
                  className="form-input font-mono hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mobile}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.mobile ? <div className="text-xs text-red-600">
                  {formik.errors.mobile}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Téléphone Professionnel</label>
                <input
                  name="telephonePro"
                  type="text"
                  className="form-input font-mono hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.telephonePro}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.telephonePro ? <div className="text-xs text-red-600">
                  {formik.errors.telephonePro}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">E-Mail</label>
                <input
                  name="email"
                  type="email"
                  className="form-input font-mono hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.email ? <div className="text-xs text-red-600">
                  {formik.errors.email}
                </div> : null}
              </div>
              {/*<div>*/}
              {/*  <label className="form-label">Genre</label>*/}
              {/*  <div className="gap-2">*/}
              {/*    <label className="flex items-center gap-1 text-xs text-gray-500 mb-1">*/}
              {/*      <input*/}
              {/*        type="radio"*/}
              {/*        name="sexe"*/}
              {/*        className="w-3 h-3  hover:cursor-not-allowed"*/}
              {/*        onChange={formik.handleChange}*/}
              {/*        onBlur={formik.handleBlur}*/}
              {/*        value="Masculin"*/}
              {/*        disabled={true}*/}
              {/*        readOnly={true}*/}
              {/*        checked={(formik.values.sexe === 'Masculin')}*/}
              {/*      /> Masculin*/}
              {/*    </label>*/}
              {/*    <label className="flex items-center gap-1 text-xs text-gray-500 mb-1">*/}
              {/*      <input*/}
              {/*        type="radio"*/}
              {/*        name="sexe"*/}
              {/*        className="w-3 h-3  hover:cursor-not-allowed"*/}
              {/*        onChange={formik.handleChange}*/}
              {/*        onBlur={formik.handleBlur}*/}
              {/*        value="Feminin"*/}
              {/*        disabled={true}*/}
              {/*        readOnly={true}*/}
              {/*        checked={(formik.values.sexe === 'Feminin')}*/}
              {/*      /> Feminin*/}
              {/*    </label>*/}
              {/*  </div>*/}
              {/*  {formik.errors.sexe ? <div className="text-xs text-red-600">*/}
              {/*    {formik.errors.sexe}*/}
              {/*  </div> : null}*/}
              {/*</div>*/}
            </div>
          </div>
          <div className="section-card">
            <div className="section-header">
              <div className="section-icon bg-purple-100 text-purple-600">
                <IconLocation/>
              </div>
              <span className="section-title">Localisation</span>
            </div>
            <div className="section-body grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <label className="form-label">Adresse</label>
                <input
                  name="adresse"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.adresse}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.adresse ? <div className="text-xs text-red-600">
                  {formik.errors.adresse}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Adresse 2</label>
                <input
                  name="adresse2"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.adresse2}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.adresse2 ? <div className="text-xs text-red-600">
                  {formik.errors.adresse2}
                </div> : null}
              </div>
              <div className="col-span-2">
                <label className="form-label">Adresse 3</label>
                <input
                  name="adresse3"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.adresse3}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.adresse3 ? <div className="text-xs text-red-600">
                  {formik.errors.adresse3}
                </div> : null}
              </div>
              <div>
                <label className="form-label">Code Postal</label>
                <input
                  name="cp"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.cp}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.cp ? <div className="text-xs text-red-600">
                  {formik.errors.cp}
                </div> : null}
              </div>
              <div>
                <label className="form-label">Ville</label>
                <input
                  name="ville"
                  type="text"
                  className="form-input hover:cursor-not-allowed"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ville}
                  disabled={true}
                  readOnly={true}
                />
                {formik.errors.ville ? <div className="text-xs text-red-600">
                  {formik.errors.ville}
                </div> : null}
              </div>
              {/*<div className="col-span-2">*/}
              {/*  <label className="form-label">Pays</label>*/}
              {/*  <input*/}
              {/*    name="pays"*/}
              {/*    type="text"*/}
              {/*    className="form-input hover:cursor-not-allowed"*/}
              {/*    onChange={formik.handleChange}*/}
              {/*    onBlur={formik.handleBlur}*/}
              {/*    value={formik.values.pays}*/}
              {/*    disabled={true}*/}
              {/*    readOnly={true}*/}
              {/*  />*/}
              {/*  {formik.errors.pays ? <div className="text-xs text-red-600">*/}
              {/*    {formik.errors.pays}*/}
              {/*  </div> : null}*/}
              {/*</div>*/}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/*<div className="fixed bottom-0 left-60 right-0 bg-white border-t border-gray-200 py-3 px-4 z-30">*/}
      {/*  <div className="max-w-[1600px] mx-auto flex items-center justify-between">*/}
      {/*    <div className="flex items-center gap-3">*/}
      {/*      <span*/}
      {/*        onClick={() => setIsActive('sinistre')}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        <IconChevronLeft className="w-4 h-4"/>*/}
      {/*        Précédent*/}
      {/*      </span>*/}
      {/*      <span*/}
      {/*        onClick={() => setIsActive('depositaire')}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Suivant*/}
      {/*        <IconChevronRight className="w-4 h-4"/>*/}
      {/*      </span>*/}
      {/*    </div>*/}
      {/*    <div className="flex items-center gap-2">*/}
      {/*      <span*/}
      {/*        onClick={() => formik.resetForm()}*/}
      {/*        className="px-3 py-1.5 border border-gray-300 rounded-lg text-gray-700 text-sm font-medium hover:bg-gray-50 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Annuler*/}
      {/*      </span>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(true)}*/}
      {/*        className="px-3 py-1.5 bg-gray-800 text-white rounded-lg text-sm font-medium hover:bg-gray-900 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isBrouillonLoading) && <IconSpinner className="animate-spin w-4 h-4"/>}*/}
      {/*        {(isBrouillonLoading) ? 'Enregistrement' : 'Brouillon'}*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(false)}*/}
      {/*        className="px-4 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isValideLoading) ? <IconSpinner className="animate-spin w-4 h-4"/> : <IconCheck className="w-4 h-4"/>}*/}
      {/*        {(isValideLoading) ? 'Enregistrement' : 'Valider'}*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*</form>*/}
    </>
  );
}

export default ProprietaireForm;